/**
 * 断点续传上传 华为云
 * https://support.huaweicloud.com/sdk-browserjs-devg-obs/obs_24_0511.html
 * 华为云 临时授权
 * https://support.huaweicloud.com/sdk-browserjs-devg-obs/obs_24_0801.html
 */

// 引入配置文件
// import ObsClient from 'esdk-obs-browserjs'
import publicUtil from './public.js'
import axios from "axios";

// 指定OBS服务相关信息：AK，SK，EndPoint
// const obsClient = new ObsClient({
//     access_key_id: '7TVJAAX5G1DMO9OIIA6I',
//     secret_access_key: 'g5DhkAzTun8F8qzvG7LBatPwG4O5nQMK4wH9z2gg',
//     server: 'https://obs.cn-east-3.myhuaweicloud.com',
// })

// 上传一体机相关固件包
// export const OBSuploadApk = (file, type, version, callback) => {
//     return new Promise((reponse) => {
//         if (!file || !version || !version) {
//             reponse(false)
//             return false
//         }
//         const currentEnv = publicUtil.envType
//         const Bucket = 'diana-file'
//         const paths = `diana/app/upgrade/${currentEnv}/${type}/${version.replaceAll('.', '_')}`
//         const fileExt = file.name.substring(file.name.lastIndexOf('.'))
//         const Key = `${paths}/1-${new Date().getTime()}${fileExt}`

//         obsClient.putObject(
//             {
//                 Bucket,
//                 Key,
//                 SourceFile: file,
//                 PartSize: 9 * 1024 * 1024, // 分段大小，单位：字节。 取值范围是100KB~5GB，默认为9MB。
//                 TaskNum: 3, // 最大并发数量
//                 ProgressCallback: function (transferredAmount, totalAmount) {
//                     if (callback) {
//                         callback((transferredAmount * 100.0) / totalAmount !== 100)
//                     }
//                 },
//             },
//             function (err, result) {
//                 if (result.CommonMsg.Status === 200) {
//                     reponse(Key.replace('diana/app', ''))
//                 } else {
//                     reponse(false)
//                 }
//             }
//         )
//     })
// }

// 上传一体机相关固件包
export function OBSuploadApk(file, type, version) {
    return new Promise((response) => {
        if (!file || !type || !version) {
            response(false);
            return false;
        }
        const method = 'put'
        const contentType = 'text/plain'
        const bucketName = 'diana-file'
        const currentEnv = publicUtil.envType
        const paths = `diana/app/upgrade/${currentEnv}/${type}/${version.replaceAll('.', '_')}`
        const fileExt = file.name.substring(file.name.lastIndexOf('.'))
        const objectKey = `${paths}/1-${new Date().getTime()}${fileExt}`

        const uploadApk = (res) => {
            const reopt = {
                method: method,
                url: res.signedUrl,
                withCredentials: false,
                headers: { 'Content-Type': contentType },
                validateStatus: function (status) {
                    return status >= 200;
                },
                maxRedirects: 0,
                responseType: 'text',
                data: file,
            };

            axios.request(reopt).then((resp) => {
                if (resp.status < 300) {
                    console.log('Creating object using temporary signature succeed.');
                    response(objectKey.replace('diana/app', ''));
                } else {
                    console.log('Creating object using temporary signature failed!');
                    console.log('status:' + resp.status);
                    console.log(resp.data);
                }
            }).catch((error) => {
                console.log(' obs temp sign error: ', error);
                response(false)
            })
        };

        axios.post(publicUtil.domain + '/adminapi/obs/temporary/url', {
            bucketName: bucketName,
            objectKey: objectKey,
            method: method,
            contentType: 'text/plain'
        }).then((res) => {
            if (res.data.error === 10000) {
                const data = JSON.parse(res.data.data);
                uploadApk(data);
            }
        }).catch((err) => {
            response(false)
            console.log(' obs temp sign err: ', err);
        })
    })
}

// 上传人脸照片压缩包
export function OBSuploadFace(file, unid) {
    return new Promise((response) => {
        if (!file || !unid) {
            response(false);
            return false;
        }
        const method = 'put'
        const contentType = 'text/plain'
        const bucketName = 'face-file'
        const currentEnv = publicUtil.envType
        const paths = `face/web/iydsj/${currentEnv}/${unid}`
        const objectKey = `${paths}/1-${Date.now()}/${file.name}`

        const uploadApk = (res) => {
            const reopt = {
                method: method,
                url: res.signedUrl,
                withCredentials: false,
                headers: { 'Content-Type': contentType },
                validateStatus: function (status) {
                    return status >= 200;
                },
                maxRedirects: 0,
                responseType: 'text',
                data: file,
            };

            axios.request(reopt).then((resp) => {
                if (resp.status < 300) {
                    console.log('Creating object using temporary signature succeed.');
                    response('/' + objectKey);
                } else {
                    console.log('Creating object using temporary signature failed!');
                    console.log('status:' + resp.status);
                    console.log(resp.data);
                }
            }).catch((error) => {
                console.log(' obs temp sign error: ', error);
                response(false)
            })
        };

        axios.post(publicUtil.domain + '/adminapi/obs/temporary/url', {
            bucketName: bucketName,
            objectKey: objectKey,
            method: method,
            contentType: 'text/plain'
        }).then((res) => {
            if (res.data.error === 10000) {
                const data = JSON.parse(res.data.data);
                uploadApk(data);
            }
        }).catch((err) => {
            response(false)
            console.log(' obs temp sign err: ', err);
        })
    })
}

// 上传红人榜照片
export function OBSuploadRedRank(file) {
    return new Promise((response) => {
        if (!file) {
            console.error('上传失败: 文件为空');
            response(false);
            return false;
        }
        const method = 'put';
        const contentType = 'text/plain';
        const bucketName = 'swapp-test-images'; // 红人榜使用的桶名
        
        // 生成日期格式 YYYYMMDD
        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const dateStr = `${year}${month}${day}`;
        
        // 获取文件名和扩展名
        const fileName = file.name;
        const objectKey = `red_rank/${dateStr}/${fileName}`;
        
        console.log('准备上传文件:', fileName);
        console.log('目标路径:', objectKey);

        // 重命名为与OBSuploadFace一致的函数名
        const uploadApk = (res) => {
            if (!res || !res.signedUrl) {
                console.error('上传失败: 获取签名URL失败');
                response(false);
                return;
            }
            
            console.log('获取到签名URL:', res.signedUrl);
            
            const reopt = {
                method: method,
                url: res.signedUrl,
                withCredentials: false,
                headers: { 'Content-Type': contentType },
                validateStatus: function (status) {
                    return status >= 200;
                },
                maxRedirects: 0,
                responseType: 'text',
                data: file,
            };

            axios.request(reopt).then((resp) => {
                if (resp.status < 300) {
                    console.log('上传成功, 状态码:', resp.status);
                    // 返回完整的URL地址，注意这里与OBSuploadFace不同
                    const fullUrl = `http://${bucketName}.iydsj.com/${objectKey}`;
                    console.log('完整URL:', fullUrl);
                    response(fullUrl);
                } else {
                    console.error('上传失败, 状态码:', resp.status);
                    console.error('响应数据:', resp.data);
                    response(false);
                }
            }).catch((error) => {
                console.error('上传请求错误:', error);
                response(false);
            });
        };

        console.log('请求临时URL...');
        axios.post(publicUtil.domain + '/adminapi/obs/temporary/url', {
            bucketName: bucketName,
            objectKey: objectKey,
            method: method,
            contentType: 'text/plain'
        }).then((res) => {
            console.log('获取临时URL响应:', res.data);
            if (res.data && res.data.error === 10000) {
                try {
                    const data = JSON.parse(res.data.data);
                    uploadApk(data); // 使用与OBSuploadFace一致的调用方式
                } catch (e) {
                    console.error('解析响应数据失败:', e);
                    response(false);
                }
            } else {
                console.error('获取临时URL失败:', res.data);
                response(false);
            }
        }).catch((err) => {
            console.error('获取临时URL请求错误:', err);
            response(false);
        });
    });
}



// WEBPACK FOOTER //
// ./src/common/huaweicloud.js